import React from "react";
import { FollowingNoticesList } from "../../../../model/notices/NoticesListModel";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { textCase } from "../../../../service/ui/UI";
import {
  imageExtensions,
  pdfExtensions,
} from "../../../../const/FileExtensions";
import { LogoImage } from "../../../../widget/common/ui/Logo";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import AppConfigService from "../../../../service/app_config/AppConfigService";
import pdfIcon from "../../../../assets/images/icons/pdf.png";
import fileIcon from "../../../../assets/images/icons/file.png";
import { toLocalDate } from "../../../../service/date_service/date_service";

const NoticesListing = (props: {
  notices: Array<FollowingNoticesList> | null;
  type?: number | undefined;
  onClickNotice: (notice: FollowingNoticesList) => void;
  handlePressStart: (notice: FollowingNoticesList) => void;
  handlePressEnd: () => void;
  selectedIds: Array<string>;
}) => {
  const notices = props.notices ?? null;
  const type: number = props.type ?? ResponsiveDeviceType();

  const imageDocHtml = (notice: FollowingNoticesList): JSX.Element => {
    let url: string = notice?.media_details?.file_url ?? "";
    const name: string = notice?.title ?? AppConfigService.get("company_name");

    if (UtilityHelper.isEmpty(url)) {
      url = UtilityHelper.isNotEmpty(notice?.branch_logo_url!)
        ? notice?.branch_logo_url!
        : AppConfigService.get("company_logo");
    }

    if (UtilityHelper.isNotEmpty(url)) {
      const urlArr: string[] | undefined = url.split(".");
      const fileExt: string = urlArr![urlArr!.length - 1];
      const size = type === 1 ? 60 : 70;

      if (imageExtensions.includes(fileExt)) {
        return <LogoImage url={url} size={size} name={name} />;
      } else if (pdfExtensions.includes(fileExt)) {
        return <img src={pdfIcon} style={{ width: size }} alt="" />;
      } else {
        return <img src={fileIcon} style={{ width: size }} alt="" />;
      }
    }

    return <></>;
  };

  return (
    <>
      {notices != null && (
        <Listing>
          {(notices ?? []).map((notice, key) => (
            <ListItem
              key={key}
              className={
                props.selectedIds.includes(notice?.group_id!)
                  ? "bgcolor-grey"
                  : ""
              }
            >
              <div
                role="button"
                className="d-flex"
                onClick={() => props.onClickNotice(notice)}
                onMouseDown={() => props.handlePressStart(notice)}
                onMouseUp={props.handlePressEnd}
                onMouseLeave={props.handlePressEnd}
                onTouchStart={() => props.handlePressStart(notice)}
                onTouchEnd={props.handlePressEnd}
              >
                <div>{imageDocHtml(notice)}</div>
                <div className="ps-4">
                  <TextBlock
                    fontSize="16_17"
                    textColor="theme-label"
                    fontName="bold"
                  >
                    {textCase(notice.title!)}
                  </TextBlock>
                  <TextBlock
                    fontSize="14_15"
                    textColor="theme-sublabel"
                    maxLine={1}
                  >
                    {textCase(notice.branch_title!)}
                  </TextBlock>
                  <TextBlock
                    fontSize="14_15"
                    textColor="theme-sublabel"
                    maxLine={1}
                  >
                    {textCase(notice.message!)}
                  </TextBlock>
                  <TextBlock fontSize="12_13" textColor="theme-sublabel">
                    {toLocalDate(notice?.create_date!)}
                  </TextBlock>
                </div>
              </div>
            </ListItem>
          ))}
        </Listing>
      )}
    </>
  );
};

export default NoticesListing;
